import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Validators, FormGroup } from '@angular/forms';

/* Services */
import { ConsultaCepService } from '../../services/consulta-cep.service';

/* Externos */
import { MessageService } from '../../messages/message.service';
import { CustomValidators } from 'ng2-validation';
import { Util } from '../../utils/util';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'endereco',
    templateUrl: './endereco.component.html',
    styleUrls: ['./endereco.component.scss']
})
export class EnderecoFormComponent implements OnInit {

    @Input() pageMode: any;
    @Input() title = 'Endereço';
    @Input() subtitle = '';
    // Controle do Mapa
    @Input() lat: number;
    @Input() lng: number;
    @Input() zoom: number;

    // Controle do checkbox
    @Output() setAddEndereco = new EventEmitter();

    @Input() group: FormGroup;

    // Output para informar que as listas estão carregadas
    @Output() countriesListLoaded = new EventEmitter();
    @Output() statesListLoaded = new EventEmitter();
    @Output() citiesListLoaded = new EventEmitter();

    // Controle do endereço exterior
    isInternacional = false;

    // Variáveis de controle os styles de validação
    MSG_CAMPO_CARACTERESESPECIAIS = Util.getMensagemCampoCaracteresEspeciais();
    MSG_CAMPO_OBRIGATORIO = Util.getMensagemCampoObrigatorio();
    MSG_CAMPO_INVALIDO = Util.getMensagemCampoInvalido();

    constructor(
        private cepService: ConsultaCepService,
        private messageService: MessageService
    ) { }

    ngOnInit() {
        // Controla as alterações feitas no forms
        this.onChanges();
    }

    onChanges(): void {
        // Seta o valueChanges pro campo Pais
        this.group.get('Endereco.Municipio.UF.Pais.CodigoAlpha3').valueChanges
            .subscribe(value => {
                const cepControl = this.group.get('Endereco.CEP');
                // Valida as changes
                if (value !== Util.getAlphaCodeBrazil()) {
                    this.limparCampos();
                    this.isInternacional = true;
                    // Ajusta os validators
                    cepControl.clearValidators();
                    cepControl.setValidators(Validators.required);
                } else {
                    this.isInternacional = false;
                    // Ajusta os validators
                    cepControl.clearValidators();
                    cepControl.setValidators([Validators.required, CustomValidators.min(8)]);
                }

                cepControl.updateValueAndValidity();
            });
    }

    limparCampos() {
        this.group.get('Endereco.CEP').setValue(null);
        this.group.get('Endereco.Logradouro').setValue(null);
        this.group.get('Endereco.Numero').setValue(null);
        this.group.get('Endereco.Bairro').setValue(null);
        this.group.get('Endereco.Complemento').setValue(null);
        this.group.get('Endereco.Municipio.Nome').setValue(null);
        this.group.get('Endereco.Municipio.UF.Sigla').setValue(null);
    }

    onblurConsultaCEP() {
        if (this.group.get('Endereco.CEP').value) {
            this.cepService.consultarCEP(this.group.get('Endereco.CEP').value)
                .subscribe(
                    dados => {
                        this.populaDadosCEPForm(dados);
                    },
                    () => {
                        this.messageService.handleMessage({
                            title: 'Oops!',
                            text: 'Ocorreu um erro ao realizar a consulta CEP :(',
                             icon: 'error'
                        });
                    });
        } else {
            this.messageService.handleMessage({
                title: 'Oops!',
                text: 'Você precisa informar um cep válido.',
                 icon: 'warning'
            });
        }
    }

    populaDadosCEPForm(dados) {

        if (dados.erro === true) {
            return;
        }

        const CodigoIBGE = (dados.ibge).substring(0, 2);

        this.group.get('Endereco.Logradouro').setValue(dados.logradouro);
        this.group.get('Endereco.Bairro').setValue(dados.bairro);
        this.group.get('Endereco.Municipio.UF.CodigoIBGE').setValue(CodigoIBGE);
        this.group.get('Endereco.Municipio.UF.Sigla').setValue(dados.uf);

        this.citiesListLoaded.subscribe(() => {

            this.group.get('Endereco.Municipio.CodigoIBGE').setValue(dados.ibge);
            this.group.get('Endereco.Municipio.Nome').setValue(dados.localidade);
        });

        this.group.get('Endereco.Logradouro').markAsTouched();
        this.group.get('Endereco.Bairro').markAsTouched();
        this.group.get('Endereco.Municipio.CodigoIBGE').markAsTouched();
        this.group.get('Endereco.Municipio.UF.CodigoIBGE').markAsTouched();
    }

    public onClickAddEndereco(check) {
        this.setAddEndereco.emit(check);
    }

    public emitCountriesLoadedEvent() {
        this.countriesListLoaded.emit();
    }

    public emitStatesLoadedEvent() {
        this.statesListLoaded.emit();
    }

    public emitCitiesLoadedEvent() {
        this.citiesListLoaded.emit();
    }
}
